import { mode, transparentize } from '@chakra-ui/theme-tools';
const getTranslucentStyles = (props) => {
    const { theme } = props;
    return {
        color: mode(transparentize('black', 0.87)(theme), 'white')(props),
        bg: mode(transparentize('white', 0.8)(theme), transparentize('gray.550', 0.8)(theme))(props),
    };
};
const getOpaqueStyles = (props) => {
    return {
        bg: mode('white', 'gray.550')(props),
    };
};
export default {
    baseStyle: {
        boxShadow: 'base',
        borderRadius: 'base',
    },
    sizes: {},
    variants: {
        translucent: getTranslucentStyles,
        opaque: getOpaqueStyles,
    },
    defaultProps: {
        variant: 'opaque',
    },
};
//# sourceMappingURL=action-button-group.js.map